<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCpconfigautotransporte" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objCpConfigAutoTransporte.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Clave">Clave</label>
							<input type="text" v-model="objCpConfigAutoTransporte.Clave" class="form-control" id="Clave" placeholder="Ingresar Clave" />
							<CValidation v-if="this.errorvalidacion.Clave" :Mensaje="'*'+errorvalidacion.Clave[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="NumEjes">Número de Ejes</label>
							<input @input="$onlyNums($event,objCpConfigAutoTransporte,'NumEjes')" type="text" v-model="objCpConfigAutoTransporte.NumEjes" class="form-control" id="NumEjes" placeholder="Ingresar Número de Ejes" />
							<CValidation v-if="this.errorvalidacion.NumEjes" :Mensaje="'*'+errorvalidacion.NumEjes[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="NumLlantas">Número de Llantas</label>
							<input @input="$onlyNums($event,objCpConfigAutoTransporte,'NumLlantas')" type="text" v-model="objCpConfigAutoTransporte.NumLlantas" class="form-control" id="NumLlantas" placeholder="Ingresar Número de Llantas" />
							<CValidation v-if="this.errorvalidacion.NumLlantas" :Mensaje="'*'+errorvalidacion.NumLlantas[0]"/>
						</div>
					</div>
						
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Remolque">Remolque</label>
							<select v-model="objCpConfigAutoTransporte.Remolque" class="form-control-search form-select" id="Remolque">
								<option value="0">0</option>
								<option value="1">1</option>
								<option value="0,1">0,1</option>
							</select>
							<CValidation v-if="this.errorvalidacion.Remolque" :Mensaje="'*'+errorvalidacion.Remolque[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCpconfigautotransporte',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCpConfigAutoTransporte: {
				IdConfigAuto: 0,
				Nombre: '',
				Clave: '',
				NumEjes: '',
				NumLlantas: '',
				Remolque: '0',
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCpConfigAutoTransporte.IdConfigAuto == 0) {
				await this.$http.post(
					'cpConfigAutoTransportes',this.objCpConfigAutoTransporte
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'cpConfigAutoTransportes/'+this.objCpConfigAutoTransporte.IdConfigAuto,
					this.objCpConfigAutoTransporte
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "cpConfigAutoTransportes/"+this.objCpConfigAutoTransporte.IdConfigAuto
            ).then((res) => {
                this.objCpConfigAutoTransporte = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCpConfigAutoTransporte.Fecha.replace(/-/g,'\/');
                this.objCpConfigAutoTransporte.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCpConfigAutoTransporte = {
				IdConfigAuto: 0,
				Nombre: '',
				Clave: '',
				NumEjes: '',
				NumLlantas: '',
				Remolque: '0',
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCpConfigAutoTransporte.IdConfigAuto = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
